import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  EventEmitter,
  ViewChild,
} from '@angular/core'
import { FormControl } from '@angular/forms'

@Component({
  selector: 'app-commision-modal',
  templateUrl: './commision-modal.component.html',
  styleUrls: ['./commision-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommisionModalComponent implements OnChanges {
  // @ViewChild('closebutton') closebutton;
  commissionFormControl = new FormControl(0)
  @Input() commisionRate: number
  @Output() updateCommission: EventEmitter<any> = new EventEmitter()
  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (this.commisionRate) {
      this.commissionFormControl.setValue(this.commisionRate)
    }
  }
}
